<template>
  <div class="button-container">
    <ButtonList :options="yesNoOptions"
    :value="value" @input="$emit('input', $event)"></ButtonList>

  </div>
</template>

<script>
import ButtonList from './ButtonList'
export default {
  data () {
    return {
      yesNoOptions: [
        { label: 'Yes', icon: '<i class="fas fa-check"></i>' }, { label: 'No', icon: '<i class="fas fa-times"></i>' }
      ],
      activeButton: null
    }
  },
  methods: {
    inputClick (value) {
      this.activeButton = value
      this.$emit('input', { value: value })
    }
  },
  created () {
    this.activeButton = this.value
  },
  props: ['options', 'value'],
  components: {
    ButtonList
  }
}
</script>
